<template>
  <label :class="['input-radio', classesObject]">
    <input
      v-bind="$attrs"
      type="radio"
      :value="value"
      :disabled="disabled"
      :checked="isSelected"
      @focus="focused = true"
      @blur="focused = false"
      @change="$emit('input', value)"
    />
    <div class="input-label inline-block">
      <slot name="label">{{ label }}</slot>
    </div>
  </label>
</template>
<script>
export default {
  name: "radio",
  inheritAttrs: false,
  model: {
    prop: "model"
  },
  props: {
    model: {
      type: [String, Number, Boolean, Object],
      required: true
    },
    value: {
      type: [String, Number, Boolean, Object],
      required: true
    },
    label: String,
    disabled: Boolean
  },

  data: () => ({
    focused: false
  }),

  computed: {
    classesObject() {
      return {
        checked: this.isSelected,
        disabled: this.disabled,
        focused: this.focused
      };
    },
    isValueObject() {
      return this.value !== null && typeof this.value === "object";
    },
    isSelected() {
      if (this.isValueObject) {
        return this.isObjectEqual(this.model, this.value);
      }

      return this.model === this.value;
    }
  },

  methods: {
    isObjectEqual(a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    }
  }
};
</script>
